// v414.71 — printable packing slip for a sale request (no prices: it's a
// fulfillment document — code, parties, items, note).
export function openPackingSlip(req) {
  const day = (iso) => (iso ? String(iso).slice(0, 10) : "");
  const esc = (s) => String(s || "").replace(/</g, "&lt;");
  const rows = (req.items || [])
    .map(
      (it) => `
    <tr>
      <td class="num">${it.quantity}</td>
      <td>${esc(it.product_name)}</td>
      <td class="muted">${esc(it.unit || "units")}</td>
      <td class="box">☐</td>
    </tr>`
    )
    .join("");
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Packing slip ${esc(req.code)}</title>
<style>
  body{font-family:Georgia,'Times New Roman',serif;color:#18181b;margin:40px;max-width:640px;}
  .brand{font-size:22px;letter-spacing:.5em;font-weight:300;}
  .rule{height:1px;background:#c9a24a;width:48px;margin:10px 0 18px;}
  h1{font-size:16px;margin:0;} .sub{color:#71717a;font-size:12px;margin:4px 0 20px;}
  .code{font-family:ui-monospace,Menlo,monospace;font-size:20px;font-weight:bold;border:2px solid #c9a24a;background:#fbf6e7;border-radius:8px;padding:6px 14px;display:inline-block;}
  table{width:100%;border-collapse:collapse;font-size:13px;margin-top:18px;}
  th{text-align:left;border-bottom:2px solid #c9a24a;padding:6px 8px;color:#71717a;font-weight:normal;text-transform:uppercase;letter-spacing:.05em;font-size:10px;}
  td{border-bottom:1px solid #e4e4e7;padding:8px;}
  .num{width:40px;text-align:center;font-weight:bold;} .muted{color:#a1a1aa;} .box{width:30px;text-align:center;font-size:16px;color:#a1a1aa;}
  .meta{font-size:13px;margin-top:4px;} .meta b{display:inline-block;min-width:90px;font-weight:600;}
  .note{margin-top:16px;font-size:12px;color:#52525b;border-left:3px solid #c9a24a;padding-left:10px;}
  .foot{margin-top:36px;color:#a1a1aa;font-size:10px;}
</style></head><body>
  <div class="brand">AXIS</div>
  <div class="rule"></div>
  <h1>Packing slip</h1>
  <div class="sub">Generated ${day(req.created_at) || day(new Date().toISOString())}</div>
  <span class="code">${esc(req.code)}</span>
  <div style="margin-top:16px;">
    <div class="meta"><b>Prepared by</b> ${esc(req.requester_name)}</div>
    ${req.customer_name ? `<div class="meta"><b>Deliver to</b> ${esc(req.customer_name)}</div>` : ""}
    ${req.fulfill_from_master ? `<div class="meta"><b>Ships from</b> Master inventory</div>` : ""}
  </div>
  <table>
    <thead><tr><th class="num">Qty</th><th>Item</th><th>Unit</th><th>✓</th></tr></thead>
    <tbody>${rows}</tbody>
  </table>
  ${req.note ? `<div class="note">${esc(req.note)}</div>` : ""}
  <div class="foot">Reference ${esc(req.code)} — include this code in the payment memo.</div>
<script>window.onload=function(){window.print();}</script></body></html>`;
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(html);
  w.document.close();
  return true;
}
